<template>
  <div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class="-nowrap" v-for="(col, i) in columns" :key="i">{{ col.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(affiliate, i) in affiliates" :key="i">
            <td :class="`${col.custom_class}`" v-for="(col, j) in columns" :key="j">
              <span v-if="['pl1_name', 'pl2_name', 'pl3_name'].includes(col.key) && affiliate[col.key]">
                <div class="row">
                  <div class="col-md-8">
                    {{ col.formatter ? col.formatter(affiliate[col.key]) : affiliate[col.key] }}
                  </div>
                  <div class="col-md-4">
                    <span
                      v-if="!limitedView"
                      class="cursor-pointer float-right simple-btn"
                      :title="$t('Partners')"
                      @click="showPartners(affiliate, col.key)"
                    >
                      <i class="fa fa-users" />
                    </span>
                  </div>
                </div>
              </span>
              <span v-else class="-nowrap">
                {{ col.formatter ? col.formatter(affiliate[col.key]) : affiliate[col.key] }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal v-model="modalPartnersPreview" :title="`${$t('Partners')} - ${levelName}`" hide-footer>
      <div>
        <b-row v-for="(p, i) in partners" :key="i">
          <b-col>
            <b-card>
              <b-row>
                <b-col>
                  <b>{{ $t('Name') }}</b
                  >: {{ p.detail.name }}
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b>{{ $t('Reward') }}</b
                  >: {{ $utils.formatMoneyFloat(parseFloat(p.reward)) }}
                  <i
                    class="text-secondary mdi mdi-information"
                    :title="`${$t('Calculation')}`"
                    v-b-popover.hover="$utils.partnerCalculation"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b>{{ $t('Percentage') }}</b
                  >: {{ $utils.formatPercent(p.detail.reward.percentage * 100) }}
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import staticData from './staticData';
export default {
  props: ['dataset'],
  computed: {
    affiliates() {
      return this?.dataset?.affiliateEntries || [];
    },
    columns() {
      return staticData().affiliateColumns();
    },
    limitedView() {
      return this.$store?.state?.partnerAccess?.id_brand ? true : false;
    }
  },
  methods: {
    showPartners(affiliate, level) {
      this.levelName = '';
      this.partners = [];

      affiliate = this.$utils.getObjectRaw(affiliate);
      this.levelName = affiliate[level];
      level = parseInt(level.replaceAll('pl', '').replaceAll('_name', ''));

      let partnerLevel = this.dataset.partnersRewards[`partnersN${level}`].find((p) => {
        return p.id == affiliate[`pl${level}_id`];
      });

      this.partners = partnerLevel.partners;
      this.modalPartnersPreview = true;
    }
  },
  data() {
    return {
      levelName: '',
      partners: [],
      modalPartnersPreview: false
    };
  }
};
</script>

<style></style>
